export default __webpack_public_path__ + "static/media/love.f1cc077f.svg";